module.exports = __webpack_public_path__ + "img/env_7.f24f5cff.jpg";